import React, { Component } from 'react';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Header from './Header';
import card1 from '../assets/images/closed-collections/card1.png';
import card2 from '../assets/images/closed-collections/card2.png';
import card3 from '../assets/images/closed-collections/card3.png';
import card4 from '../assets/images/closed-collections/card4.png';
import artistPic from '../assets/images/closed-collections/profile-picture.png';

class ClosedCollection extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Hero slider start */}
                <div className="container-fluid">
                    <Link to="/Collection">
                        <div className="row closed-header justify-content-center">
                            <div className="header-text col-lg-7 col-sm-12">
                            </div>
                            <div className="col-lg-4 col-sm-10 artist text-center">
                                <span>Duke Dumont</span>
                                <h6>DREAM LOGIC Open Editions with LOREM & MattAttack   </h6>
                                <h1>March 19</h1>
                                <p>1:30 PM EST Drawings</p>
                                <p>2:30 PM EST Open Editions</p>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* Hero slider end */}

                {/* Collection content area start */}
                <div className="container margin-70 text-center collection-content">
                    <div className="row justify-content-center">
                        <div className="col-md-10 text-center">
                            <h3>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</h3>
                            <p>“DREAM LOGIC” is a collection from Multi-platinum, GRAMMY® nominated artist Duke Dumont, in collaboration with fellow artists LOREM & MattAttack. The trio formulated the collection to conjure dreamlike states, themed around Mind & Matter.</p>
                            <p>
                                Duke Dumont says, “My goal for the collection is to make it nonsensical too many, and make absolute sense to a few . The meaning ought to be in the eye of the beholder, not dictated by the creators.”
                            </p>
                            <p>
                                Visual artist LOREM is a self-taught creative who worked all over the world , and currently based in Germany. With the ability to define motion and precisely encapsulate the emotion within, his artworks create a deep and almost hypnotic understanding about what keeps us going and simultaneously holds us back.
                            </p>
                            <p>
                                MattAttack is an analog collage and motion artist from Athens, Georgia. Making collages out of physical materials found at garage sales, estate sales and thrift stores. His compositions centered around abstract and alternate reality themes with a future-nostalgic aesthetic.</p>
                        </div>
                    </div>
                    {/* Closed COllection cards area start */}
                    <h1>Collection Closed</h1>
                    <div className="closed-collection text-left justify-content-center row">
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/ClosedCollectionDetails">
                                    <img src={card1} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/ClosedCollectionDetails">
                                        <h3>Self-Reflection Cosmos</h3>
                                    </Link>
                                    <h5>$1,499.00</h5>
                                    <p className="card-text">2 Editions minted</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/ClosedCollectionDetails">
                                    <img src={card2} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/ClosedCollectionDetails">
                                        <h3>Morganite</h3>
                                    </Link>
                                    <h5>$1,499.00</h5>
                                    <p className="card-text">1 Editions minted</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/ClosedCollectionDetails">
                                    <img src={card3} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/ClosedCollectionDetails">
                                        <h3>Imagination Yields</h3>
                                    </Link>
                                    <h5>$1,499.00</h5>
                                    <p className="card-text">9 Editions minted</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/ClosedCollectionDetails">
                                    <img src={card4} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/ClosedCollectionDetails">
                                        <h3>Amethyst</h3>
                                    </Link>
                                    <h5>$1,499.00</h5>
                                    <p className="card-text">9 Editions minted</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Closed COllection cards area end */}

                    {/* Why love arae start */}
                    <div className="row mb-5 justify-content-center">
                        <div className="col-md-10">
                            <h3>Why we love Duke Dumont</h3>
                            <Link to="/UserProfileArtist"><img src={artistPic} alt="artistPic" className="collection-artist-pic" /></Link>
                            <p>We are excited to welcome Duke Dumont, LOREM, and MattAttack to Nifty Gateway! The trio have collaborated together in the past and they have combined forces for their first NFT release 'DREAM LOGIC'! Welcome to NG!</p>
                            <h3>Follow Duke Dumont to receive exclusive release info</h3>
                            <button>Follow</button>
                            <h3>Learn More about Art Vader</h3>
                            <h6><Link to="#">https://website.com</Link></h6>
                            <h6><Link to="#">https://socialmedia.com</Link></h6>
                        </div>
                    </div>
                    {/* Why love arae end */}
                </div>
                {/* Collection content area end */}
            </div >
        )
    }
};

export default ClosedCollection;